import Navbar from '../../../Components/Nav';
import { IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useState } from 'react';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'; // Optional theme CSS
import ChangePageTitle from '../../../Components/ChangePageTitle';
import { FiSearch } from 'react-icons/all';
import AlumniTable from '../../../Components/AlumniTable/AlumniTable';
import { CloseIcon } from '@chakra-ui/icons';

export default function AllAlumni() {
  const [searchString, setSearchString] = useState('');

  const handleChange = (event) => setSearchString(event.target.value);

  return (
    <>
      <ChangePageTitle pageTitle='Registered Alumni - Alumni Connect 2026'></ChangePageTitle>
      <Navbar breadCrumb={['Members', 'All Alumni']}>

        <div className="search-bar-section">
          {/*Search field*/}
          <div className="search-bar-field">
            <InputGroup>
              <Input
                variant='filled'
                bg='white'
                _focus={{
                  bg: 'white'
                }}
                placeholder='Enter Search String'
                value={searchString}
                onChange={handleChange}
              />
              <InputRightElement>
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            <IconButton
              ml='8px'
              colorScheme='red'
              aria-label='Clear Icon'
              icon={<CloseIcon />}
              onClick={() => setSearchString('')}
            />
          </div>
        </div>

        <div className='full-table'>
          <AlumniTable searchString={searchString} setSearchString={setSearchString}/>
        </div>

      </Navbar>
    </>
  );
}
